// @ts-nocheck
(function(){
  function computeOrder(grid){
    var slots = Array.from(grid.querySelectorAll('.bento-slot:not(.has-slideshow)'));
    var cards = slots.map(function(slot){ return slot.querySelector('.bento-card--collection'); }).filter(Boolean);
    if(!cards.length) return [];
    // Measure and group by row using top position tolerance
    var items = cards.map(function(card){
      var r = card.getBoundingClientRect();
      return { card: card, top: Math.round(r.top), left: Math.round(r.left) };
    });
    // Normalize rows: cluster by top within 10px
    items.sort(function(a,b){ return a.top - b.top || a.left - b.left; });
    var rows = [];
    var tol = 10;
    items.forEach(function(it){
      var row = rows.find(function(rr){ return Math.abs(rr.top - it.top) <= tol; });
      if(!row){ rows.push({ top: it.top, items: [it] }); }
      else { row.items.push(it); }
    });
    // Sort each row by left and flatten
    var order = [];
    rows.forEach(function(row){ row.items.sort(function(a,b){ return a.left - b.left; }); order = order.concat(row.items); });
    return order.map(function(o){ return o.card; });
  }
  function applyDelays(grid){
    var orderedCards = computeOrder(grid);
    if(!orderedCards.length) return;
    var stepMs = 120;
    orderedCards.forEach(function(card, i){
      try { card.style.animationDelay = (i * stepMs) + 'ms'; } catch(e) {}
    });
  }
  function init(grid){
    if(!(grid instanceof HTMLElement)) return;
    grid.setAttribute('data-animating', 'true');
    applyDelays(grid);
    var cards = grid.querySelectorAll('.bento-slot:not(.has-slideshow) .bento-card--collection');
    if(!cards.length){ grid.removeAttribute('data-animating'); return; }
    var remaining = 0;
    cards.forEach(function(card){
      var cs = getComputedStyle(card);
      if (!cs || !cs.animationDuration || cs.animationDuration === '0s') return;
      remaining++;
      var done = false;
      card.addEventListener('animationend', function(){
        if (done) return; done = true; remaining--; if(remaining <= 0){ grid.removeAttribute('data-animating'); }
      }, { once: true });
    });
    setTimeout(function(){ grid.removeAttribute('data-animating'); }, 2000);
  }
  function boot(){
    document.querySelectorAll('.bento-grid__inner[data-layout="freeform"]').forEach(init);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})(); 